// eslint-disable-next-line consistent-return
export const min = (value, length) => {
  const message = `Mínimo de caracteres aceitos: ${length}`;
  if (value) {
    if (value.length < length) {
      return message;
    }
  }
  return true;
};

export const max = (value, length) => {
  const message = `Máximo de caracteres aceitos: ${length}`;
  if (value) {
    if (value.length > length) {
      return message;
    }
  }
  return true;
};

export const email = (value) => !!/.+@.+\..+/.test(value) || 'E-mail inválido';

export const required = (value) => !!value || 'Campo requerido.';

export const requiredBool = (value) => (typeof value === 'boolean') || 'Campo requerido.';

export default {
  max,
  email,
  required,
  requiredBool,
};
